<template>
  <div class="home">
    
    <!-- Image slider -->
    <div id="picture_carousel" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
      </div>
      <div class="carousel-inner">
        <div class="carousel-item active" data-bs-interval="2500">
          <img src="@/assets/stage_400_600.png" class="object-fit-scale rounded" alt="...">
        </div>
        <div class="carousel-item" data-bs-interval="2500">
          <img src="@/assets/MD_bearbeitet_400_600.jpg" class="object-fit-scale rounded" alt="...">
        </div>
        <div class="carousel-item" data-bs-interval="2500">
          <img src="@/assets/rothensee_400_600.jpg" class="object-fit-scale rounded" alt="...">
        </div>
      </div> 
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>

    <div style="text-align:left" class="container font-custom text-white">
      <h1 ><b><color_yellowgreen>Rock aus</color_yellowgreen> <color_orange>Magdeburg</color_orange></b></h1>

      <h2>Was spielen wir?</h2>
      <ul>
        <li>Eigene Rock-Songs und Balladen</li>
        <li>Cover-Songs</li>
      </ul>
    </div>
    
  </div>
</template>

<style>
  .carousel {
    border-bottom: 2px solid #888
  }

  .carousel-inner {
    height: 400px; /* Feste Höhe für alle Bilder */
    width: 100%;   /* Breite anpassen */
    justify-content: center;
  }

</style>

<script>
  
</script>
